import React, { useContext, useEffect, useState } from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import useDeviceDetect from "../isMobile";
import Heading from "../Heading";
import TextField from "../TextField";
import TextAreaField from "../TextAreaField";
import "./createSale.scss";
import Loader from "../../../loading";
import { toast } from "react-toastify";
import createdTokenABI from "../../../utils/createdTokenAbi.json";
import { Contract } from "@ethersproject/contracts";
import { UseSalesContract } from "../../../ConnectivityAss/hooks";
import { saleContractAddress } from "../../../utils/environment";
import axios from "axios";
import { url } from "../../../utils";
import moment from "moment";
import { Box } from "@mui/system";
import { AppContext } from "../../../utils";
import { parseUnits } from "@ethersproject/units";
import CheckboxRadio from "../CheckboxRadio";

const tabsData = [
  {
    label: "Token information",
    step: 1,
    disabled: true,
  },
  {
    label: "Sales information",
    step: 2,
    disabled: true,
  },
  {
    label: "Soft/Hard Cap ",
    step: 3,
    disabled: true,
  },

  {
    label: "Additional information",
    step: 4,
    disabled: true,
  },
  {
    label: "Details",
    step: 5,
    disabled: true,
  },
];

const CreateSale = () => {
  const { account, signer } = useContext(AppContext);
  const { isMobile } = useDeviceDetect();
  const salesContract = UseSalesContract(signer);

  const [tabs, setTabs] = useState(tabsData);
  const [activeTab, setActiveTab] = useState(1);
  // TOKEN INFORMATION
  const [tokenAddress, setTokenAddress] = useState("");
  const [tokenSymbol, setTokenSymbol] = useState("-");
  const [tokenDecimel, setTokenDecimel] = useState("-");
  const [tokenName, settokenName] = useState("-");
  const [tokenContract, settokenContract] = useState("-");
  //  SALES INFORMATION
  const [hardCap, sethardCap] = useState("");
  const [tokensOnSale, settokensOnSale] = useState("");
  const [softCap, setsoftCap] = useState("");
  const [priceOfTokenOnSales, setPriceOfTokenOnSales] = useState("");
  const [startTime, setstartTime] = useState(new Date().getTime());
  const [endTime, setendTime] = useState(new Date().getTime());
  const [tokenAllowance, settokenAllowance] = useState("");
  // PANCAKE LISTING
  // ERROR STATE
  const [tokenError, settokenError] = useState(false);
  const [loading, setloading] = useState(false);

  // Additional info
  const [logoLink, setlogoLink] = useState(
    "https://bscpad.com/images/gfx-e.png"
  );
  const [coverImage, setcoverImage] = useState(
    "https://storage.googleapis.com/polkastarter-production-assets/54tb6ki60chdr3lip392cduk66zl"
  );
  const [webLink, setwebLink] = useState("https://bscpad.com/images/gfx-e.png");
  const [githubLink, setgithubLink] = useState(
    "https://bscpad.com/images/gfx-e.png"
  );
  const [twitterLink, settwitterLink] = useState(
    "https://bscpad.com/images/gfx-e.png"
  );
  const [redditLink, setredditLink] = useState(
    "https://bscpad.com/images/gfx-e.png"
  );
  const [telegramLink, settelegramLink] = useState(
    "https://bscpad.com/images/gfx-e.png"
  );
  const [projectDescription, setprojectDescription] = useState(
    "https://bscpad.com/images/gfx-e.png"
  );
  const [updateyouwant, setupdateyouwant] = useState(
    "https://bscpad.com/images/gfx-e.png"
  );
  const [projectName, setprojectName] = useState("test");
  const [txHash, settxHash] = useState("");
  // VALIDATION FUNCTIONS STARTS FROM HERE
  const [totalNumber0fTokens, settotalNumber0fTokens] = useState("");
  //Liquidity Check
  const [saleType, setsaleType] = useState("Liquidity");

  const tokenAddressHandler = async (address) => {
    try {
      setloading(true);
      setTokenAddress(address);
      if (!account) {
        toast.error("Please connect your wallet first.");
      }

      if (address.length == 42 && account) {
        setloading(true);
        const TokenContract = await new Contract(
          address,
          createdTokenABI,
          signer
        );
        const decimals = await TokenContract.decimals();
        const name = await TokenContract.name();
        const symbol = await TokenContract.symbol();
        const tNumberOftokens = await TokenContract.balanceOf(account);
        const allowance = await TokenContract.allowance(
          account,
          saleContractAddress
        );
        settokenAllowance(allowance);
        setTokenSymbol(symbol);
        setTokenDecimel(decimals);
        settokenName(name);
        settokenContract(TokenContract);
        settotalNumber0fTokens(tNumberOftokens);
        setloading(false);
      } else {
        toast.success("You can chenge the zero address");
        setloading(false);
      }
    } catch (error) {
      setloading(false);
      toast.error("invalid token address");
      console.log(error);
    }
  };

  useEffect(() => {
    if (account && tokenAddress) {
      tokenAddressHandler(tokenAddress);
    }
  }, [account, tokenAddress]);

  // const tokenApprovalHandler = async () => {
  //   if (!account) {
  //     toast.error("Error! Please connect your wallet .");
  //   } else if (!totalNumber0fTokens) {
  //     toast.error("Error! Please get total number of tokens ");
  //   } else {
  //     setloading(true);
  //     try {
  //       const tx = await tokenContract.approve(
  //         saleContractAddress,
  //         totalNumber0fTokens.toString()
  //       );
  //       await tx.wait();
  //       toast.success("Transection Confirmed");
  //       settxHash("https://testnet.bscscan.com/tx/" + tx.hash);
  //       settokenApproval(true);
  //       setActiveTab(2);
  //       if (saleType == "NoLiquidity") {
  //         setTabs(tabsData1);
  //       }
  //       tokenAddressHandler(tokenAddress);
  //       setloading(false);
  //     } catch (error) {
  //       if (error?.data?.message) {
  //         toast.error(error?.data?.message);
  //       } else {
  //         toast.error(error?.message);
  //       }
  //       setloading(false);
  //     }
  //   }
  // };

  const createPresaleHandler = async () => {
    if (!account) {
      toast.error("Error! Please connect your wallet ");
    } else if (!account) {
      toast.error("Error! Please connect your wallet");
    } else if (tokenError) {
      toast.error("Error! Please enter valid token Adrress");
    } else if (!hardCap) {
      toast.error("Error! Please enter Soft Cap.");
    } else if (
      !logoLink ||
      !webLink ||
      !twitterLink ||
      !projectName ||
      !telegramLink
    ) {
      toast.error(
        "Error! Please fill all required* additional informations correctly."
      );
    } else {
      setloading(true);
      try {
        let _preSaleData = [
          priceOfTokenOnSales,
          startTime.toString(),
          endTime.toString(),
          parseUnits(hardCap.toString()).toString(),
          parseUnits(softCap.toString()).toString(),
        ];
        const preSale = await salesContract.createPreSaleBUSD(
          tokenAddress,
          _preSaleData
        );
        await preSale.wait();
        const contractAddress = await salesContract.getPreSale(tokenAddress);
        const fData = {
          tokenAddress,
          tokenName,
          tokenSymbol,
          tokenDecimel,
          saleType,
          priceOfTokenOnSales,
          contractAddress,
          hardCap,
          softCap,
          logoLink,
          coverImage,
          webLink,
          githubLink,
          twitterLink,
          redditLink,
          telegramLink,
          projectDescription,
          updateyouwant,
          startTime,
          endTime,
          projectName,
          account,
        };
        const { data } = await axios.post(`${url}/presaleRouter/IOD`, fData);
        if (data.success) {
          toast.success(data.message);
          setloading(false);
        } else {
          toast.error(data.message);
          setloading(false);
        }
      } catch (error) {
        if (error?.data?.message) {
          toast.error(error?.data?.message);
          setloading(false);
        } else {
          toast.error(error?.message);
          setloading(false);
        }
      }
    }
  };
  const switchTab = (step) => {
    setTabs(
      tabs.map((item) =>
        item.step === step ? { ...item, disabled: false } : item
      )
    );
    setActiveTab(step);
  };

  const clickBack = () => {
    if (activeTab === 1) return;
    switchTab(activeTab - 1);
  };
  const clickNext = () => {
    if (activeTab === 5) {
      return;
    } else if (activeTab === 1 && !tokenAddress) {
      toast.error("Error! Please enter token Adrress");
    } else if (activeTab === 2 && !tokensOnSale && !priceOfTokenOnSales) {
      toast.error("Error! Please enter tokens and price of tokens on sale.");
    } else if (activeTab === 3 && !softCap && !hardCap) {
      toast.error("Error! Please enter valid values of Softcap and Hardcap.");
    } else {
      switchTab(activeTab + 1);
    }
  };

  const buttonHtml = (
    <div className="createSaleNext dFA jcSB">
      {activeTab > 1 ? (
        <span className="back cP" onClick={clickBack}>
          Back
        </span>
      ) : null}

      {activeTab === 1 ? (
        <span className="button cP" onClick={clickNext}>
          Next
        </span>
      ) : (
        <span
          className="button cP"
          onClick={() =>
            activeTab === 5 ? createPresaleHandler() : clickNext()
          }
        >
          {activeTab === 5 ? "Submit" : "Next"}
        </span>
      )}
    </div>
  );

  return (
    <div
      style={{ paddingTop: "50px", paddingBottom: "100px" }}
      className="container pdt50 createSale"
    >
      <Loader loading={loading} />
      <Heading className="saleHeading" headingText="Create sale" />
      <div className={`createSaleBox ${isMobile ? "" : "oH"}`}>
        <div className="tabs pR">
          <Tabs
            className={`${!isMobile ? "dF" : ""}`}
            selectedIndex={activeTab - 1}
            onSelect={(index) => {
              setActiveTab(index + 1);
            }}
          >
            <TabList className="leftSide w100">
              {tabs.map((item, i) => {
                const tabProps = {
                  disabled: item.disabled,
                  className: activeTab - 1 >= i ? "active" : "",
                };

                return (
                  <Tab key={i} {...tabProps}>
                    <div className="mSite">{item.label}</div>
                    <span>
                      <b>{item.step}</b>
                    </span>
                  </Tab>
                );
              })}
            </TabList>
            <div className="tabsPanels w100">
              {/* Token information */}
              <TabPanel>
                <div className="createSaleFields">
                  <div className="fieldTextRow">
                    <TextField
                      type="text"
                      placeholder="Enter here"
                      label="Token address"
                      className="fieldText"
                      value={tokenAddress}
                      onChange={(e) => {
                        if (e.target.value.length == 42) {
                          tokenAddressHandler(e.target.value);
                        }
                        setTokenAddress(e.target.value);
                      }}
                      maxLength={42}
                    />
                    <TextField
                      type="text"
                      placeholder="Enter here"
                      label="Token symbol"
                      className="fieldText"
                      value={tokenSymbol}
                      readOnly
                    />

                    <TextField
                      type="text"
                      placeholder="Enter here"
                      label="Token decimal"
                      className="fieldText"
                      value={tokenDecimel}
                      readOnly
                    />
                  </div>
                </div>

                {buttonHtml}
              </TabPanel>
              {/* Sales information limit */}
              <TabPanel>
                <div className="createSaleFields">
                  <div className={`${isMobile ? "" : "dF"}`}>
                    <div className="fieldTextRow">
                      {/* <TextField
                        type="text"
                        placeholder="Enter here"
                        label="Token for sale"
                        className="fieldText"
                        value={tokensOnSale}
                        onChange={(e) => settokensOnSale(e.target.value)}
                      /> */}
                      <TextField
                        type="text"
                        placeholder="Enter here"
                        label="Tokens per BUSD"
                        className="fieldText"
                        value={priceOfTokenOnSales}
                        onChange={(e) => setPriceOfTokenOnSales(e.target.value)}
                      />
                    </div>
                    <div className="fieldTextRow">
                      <TextField
                        type="datetime-local"
                        placeholder="Enter here"
                        label="Sale start"
                        className="fieldText"
                        onChange={(e) => {
                          setstartTime(moment(e.target.value).format("X"));
                        }}
                      />
                      <TextField
                        type="datetime-local"
                        placeholder="Enter here"
                        label="Sale end"
                        className="fieldText"
                        onChange={(e) => {
                          setendTime(moment(e.target.value).format("X"));
                        }}
                      />
                    </div>
                  </div>
                </div>
                {buttonHtml}
              </TabPanel>
              <TabPanel>
                <div className="createSaleFields">
                  <div className="fieldTextRow">
                    <TextField
                      type="text"
                      placeholder="Enter BNB"
                      label="Soft cap"
                      className="fieldText"
                      QuestionIcon
                      value={softCap}
                      onChange={(e) => setsoftCap(e.target.value)}
                    />
                    <TextField
                      type="text"
                      placeholder="Enter BNB"
                      label="Hard cap"
                      className="fieldText"
                      QuestionIcon
                      value={hardCap}
                      onChange={(e) => sethardCap(e.target.value)}
                    />
                  </div>
                </div>

                {buttonHtml}
              </TabPanel>
              {/* Sales type */}

              {/* Additional information */}
              <TabPanel>
                <div className="createSaleFields">
                  <div className={`${isMobile ? "" : "dF"}`}>
                    <div className="fieldTextRow">
                      <TextField
                        type="text"
                        placeholder="Enter here"
                        label="Project name"
                        className="fieldText"
                        QuestionIcon
                        value={projectName}
                        onChange={(e) => setprojectName(e.target.value)}
                      />
                      <TextField
                        type="text"
                        label="Medium link"
                        className="fieldText"
                        QuestionIcon
                        value={githubLink}
                        onChange={(e) => setgithubLink(e.target.value)}
                        placeholder="Ex. https://www.medium..."
                      />
                      <TextField
                        type="text"
                        label="Reddit link"
                        className="fieldText"
                        QuestionIcon
                        value={redditLink}
                        onChange={(e) => setredditLink(e.target.value)}
                        placeholder="Ex. https://www.Reddit..."
                      />
                    </div>
                    <div className="fieldTextRow">
                      <TextField
                        type="text"
                        label="Website link"
                        className="fieldText"
                        QuestionIcon
                        value={webLink}
                        onChange={(e) => setwebLink(e.target.value)}
                        placeholder="Ex. https://www.galaxypad"
                      />
                      <TextField
                        type="text"
                        label="Logo link"
                        className="fieldText"
                        QuestionIcon
                        value={logoLink}
                        onChange={(e) => setlogoLink(e.target.value)}
                        placeholder="Ex. https://www.galaxypad/logo.png"
                      />
                    </div>
                    <div className="fieldTextRow">
                      <TextField
                        type="text"
                        label="Telegram link"
                        className="fieldText"
                        QuestionIcon
                        value={telegramLink}
                        onChange={(e) => settelegramLink(e.target.value)}
                        placeholder="Ex. https://t.me..."
                      />
                      <TextField
                        type="text"
                        label="Twitter link"
                        className="fieldText"
                        QuestionIcon
                        value={twitterLink}
                        onChange={(e) => settwitterLink(e.target.value)}
                        placeholder="Ex. https://www.twitter..."
                      />
                      <TextField
                        type="text"
                        label="Cover Image"
                        className="fieldText"
                        QuestionIcon
                        value={coverImage}
                        onChange={(e) => setcoverImage(e.target.value)}
                        placeholder="https://storage.googleapis.com/polkastarter-production-assets/54tb6ki60chdr3lip392cduk66zl"
                      />
                    </div>
                  </div>
                  <div className="projectDescription">
                    <div className={`${isMobile ? "" : "dF"}`}>
                      <TextAreaField
                        type="textarea"
                        placeholder="https://bscpad.com/images/gfx-e.png"
                        label="Project description"
                        className="textAreas"
                        QuestionIcon
                        value={projectDescription}
                        onChange={(e) => setprojectDescription(e.target.value)}
                      />
                      <div className="fieldTextRow wChange">
                        <TextField
                          type="text"
                          placeholder="Enter here"
                          label="Updates you want"
                          className="fieldText"
                          QuestionIcon
                          value={updateyouwant}
                          onChange={(e) => setupdateyouwant(e.target.value)}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                {/* <h1> tab 6 </h1> */}

                {buttonHtml}
              </TabPanel>
              <TabPanel>
                <div className="createSaleFields">
                  <Box>Token name : {tokenName.toString()}</Box>
                  <Box mt={1}>Token Symbol : {tokenSymbol.toString()}</Box>
                  <Box mt={1}>
                    Price per BNB : {priceOfTokenOnSales.toString()}
                  </Box>
                  <Box mt={1}>
                    Start Time :{" "}
                    {moment.unix(startTime.toString()).format("LL")}
                  </Box>
                  <Box mt={1}>
                    End Time : {moment.unix(endTime.toString()).format("LL")}
                  </Box>

                  <Box mt={1}>Softcap : {softCap.toString()}</Box>
                  <Box mt={1}>Hardcap : {hardCap.toString()}</Box>
                </div>

                {buttonHtml}
              </TabPanel>
            </div>
          </Tabs>
        </div>
      </div>
    </div>
  );
};

export default CreateSale;
